import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { scrollBottom } from '@/helpers/utils';
import { Select } from './Select';
import IconTrash from './icon_trash.svg';
import IconCirclePlus from './icon_plus_circle.svg';
import s from './index.module.scss';

export const AddAdditionalDocument = ({ data, visibleDocs, onSelect }) => {
  const { t } = useTranslation('compliance');
  const [show, setShow] = useState(false);

  const options = useMemo(() => {
    return data.documents.required_documents
      .filter(
        file => !file.is_required && !visibleDocs.includes(file.document_type),
      )
      .map(item => ({
        value: item.document_type,
        label: t(`documents.${item.document_type.toLowerCase()}`),
      }));
  }, [data, visibleDocs, t]);

  useEffect(() => {
    setShow(false);
  }, [visibleDocs.length]);

  useEffect(() => {
    show && scrollBottom();
  }, [show]);

  if (!options.length) return null;

  return (
    <>
      {show && (
        <div className={s.select_row}>
          <Select
            label={t('form.document_type_label')}
            name="document_type"
            options={options}
            className={s.select}
            placeholder={t('form.document_type_placeholder')}
            onChange={onSelect}
          />
          <button type="button" className={s.btn_remove} onClick={() => setShow(false)}>
            <img src={IconTrash} alt="trash" width={20} height={20} />
          </button>
        </div>
      )}
      <button type="button" className={s.btn_add} onClick={() => setShow(true)}>
        <img src={IconCirclePlus} alt="icon" width={20} height={20} />
        <span className="f-small-accent">
          {t('form.add_additional_document')}
        </span>
      </button>
    </>
  );
};